export enum EmailValidationType {
  INVALID = 'INVALID',
  VALID = 'VALID',
  WARNING = 'WARNING',
}

export enum CustomEmailValidationType {
  SUSPICIOUS = 'SUSPICIOUS',
  SUGGESTION = 'SUGGESTION',
  UNVERIFIED_BY_USER = 'UNVERIFIED_BY_USER',
  ERROR = 'ERROR',
}
